import styled from 'styled-components'

export const OverlayContainer = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
`

export const LoadingBarContainer = styled.div`
  position: absolute;
  width: 50vw;
  z-index: 6;
  top: 70vh;
  top: 70dvh;
  left: 0;
  left: 25vw;
`

export const GuideContainer = styled.div`
  height: 100vh;
  height: 100dvh;
  width: 100vw;
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0;
  background-color: rgb(250, 250, 250);

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 65vh 58px;
  gap: 50px;
`
